module.exports = __webpack_public_path__ + "static/media/favicon.be291880.ico";